/*
 * @Author: bbqin
 * @Date: 2022-01-11 11:18:26
 * @LastEditTime: 2022-11-10 20:53:57
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\CardContainer\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, Fragment } from 'react';
import { BaseComponent } from '@platform/template';
import { Tooltip } from '@platform/base';
import useCardContainer from './store';
import { linkTo, getLangCode, changeTime, formatNumber, formatDatetime, formatAcuracyRound, toast } from '@platform/api';
import Hyperlink from '../Hyperlink';

const defaultProps = {
    prefixCls: 'card-container',
    data: [],
    value: '',
    title: '',
    icon: '',
};

const CommonIcon = require(`../../static/images/pageMainIcon/formCoreGroupIcon/cd-common-other1.svg`);

require('./index.less');

const isIE = (
    navigator.userAgent.indexOf("MSIE") != -1 || !!window.ActiveXObject || "ActiveXObject" in window
);

class CardContainer extends BaseComponent {
    constructor(props) {
        super(props);
        const { store, id, visible = true } = props;
        store.setStore('name', id, false);
        store.setStore('visible', visible, false);
    }

    getItemsDom = (data, items) => {
        let { prefixCls, pageId, langJson = {} } = this.props;

        return items.map((item, i) => {
            let {
                label, itemtype, showFractile, isconverttimezones,
                icontype, attrcode, hyperlinkflag, areacode, render,
                datatype, hyperlinktype, hyperlinkname, hyperlinkurl,
                iscoredata,
            } = item;
            if (!iscoredata) {
                return null;
            }
            let values = data[attrcode] || {};

            let value = values.display || values.value;
            icontype = icontype || CommonIcon;

            // 记录一份原始value
            let elementValue = values.value;

            // 数值
            if (itemtype === 'number') {
                let scale = values.scale;
                if (scale === undefined || scale === null || scale == '-1' || scale == -1) {
                    scale = item.scale;
                }
                if (scale === undefined || scale === null || scale == '-1' || scale == -1) {
                    scale = 0;
                }
                showFractile = typeof (showFractile) === 'boolean' ? !showFractile : false;
                value = formatNumber(formatAcuracyRound(value, Number(scale), showFractile), false, !showFractile);
            }

            // 日期
            switch (itemtype) {
                case 'datetimepicker':
                case 'NCTZDatePickClientTime':
                    value = changeTime(value, 'YYYY-MM-DD HH:mm:ss', isconverttimezones);
                    value = formatDatetime(value, 'datetime');
                    break;
                case 'NCTZDatePickerStart':
                case 'NCTZDatePickerEnd':
                case 'NCTZDatePickClientHourTime':
                case 'datepicker':
                    value = changeTime(value, 'YYYY-MM-DD', isconverttimezones);
                    value = formatDatetime(value, 'date');
                    break;
                case 'datePickerNoTimeZone':
                    value = formatDatetime(value, 'date');
                    break;
                case 'timepicker':
                    value = formatDatetime(value, 'time');
                    break;
            }

            // 超链接
            let valueDom = value;
            valueDom = hyperlinkflag ? <Hyperlink
                datatype={datatype}
                hyperlinkflag={hyperlinkflag}
                hyperlinktype={hyperlinktype}
                hyperlinkname={hyperlinkname}
                hyperlinkurl={hyperlinkurl}
                value={elementValue}
                browse={true}
                pageId={pageId}
                areaCode={areacode}
                attrCode={attrcode}
                dataId={elementValue}
                className={'form-hyperlink'}
            >{valueDom}</Hyperlink> : valueDom;

            // 自定义render
            valueDom = render ? render(item, this.props) : valueDom;

            return <div
                key={i}
                className={`${prefixCls}-item`}
            >
                <div className={`${prefixCls}-left`}>
                    <div className={`${prefixCls}-icon`}><img src={icontype} alt="图" /></div>
                </div>
                <div className={`${prefixCls}-right`}>
                    <div className={`${prefixCls}-title`}><div className={`${prefixCls}-ellipsis`} title={label}>{label}</div></div>
                    <div className={`${prefixCls}-value ${hyperlinkflag ? 'hyper-link-wrapper' : ''}`}>
                        <div className={`${prefixCls}-value-content `}>
                            <div className={`${prefixCls}-ellipsis ${isIE ? 'ie-browser' : ''} `}
                                title={value}
                            >{valueDom}</div>
                        </div>
                    </div>
                </div>
            </div>;
        });
    };

    render() {
        let { prefixCls, store, id } = this.props;
        let meta = store.getViewMeta(id);
        let visible = store.getStore('visible');
        if (!meta.length || !visible) {
            return <div></div>;
        }
        let data = store.getData();
        let DOM = [];
        let items = [];
        meta.forEach((item, i) => {
            // 每四个换行
            let isClearFix = i % 4 === 3;
            items.push(item);
            if (isClearFix || item.wordwrap) {
                DOM.push(<div className={`${prefixCls}-row ${items.length === 4 ? 'row-4-item' : ''}`}>{this.getItemsDom(data, items)}</div>);
                items = [];
            }
        });
        // 剩余的项，未满一行的项
        items.length && DOM.push(<div className={`${prefixCls}-row ${items.length === 4 ? 'row-4-item' : ''}`}>{this.getItemsDom(data, items)}</div>);
        return <div className={`${prefixCls}-wrapper `} id={`cardContainer_${id}`}>
            {DOM}
        </div>;
    }
}

CardContainer.defaultProps = defaultProps;
CardContainer.displayName = 'CardContainer';
CardContainer.useCardContainer = useCardContainer;

export default CardContainer;